/*------------------------------------------------
// File Name:PDM_CONFIG_KEY.js
// File Description:PDM_CONFIG_KEY store方法
// Author:zxl
// Create Time:2022/08/19 16:25:34
//------------------------------------------------*/

import {
    GetPDM_CONFIG_KEYList,
    GetPDM_CONFIG_KEYListByPage,
    GetPDM_CONFIG_KEYEntity,
    CreatePDM_CONFIG_KEYEntity,
    UpdatePDM_CONFIG_KEYEntity,
    DeletePDM_CONFIG_KEYEntity,
} from '@/api/pdm/configKey'

import msg from '@/config/notify'
import dlg from '@/config/dialog'
//import { toRaw } from "vue";

export const PdmConfigKey = {
    namespaced: true,
    state: {
        PdmConfigKeyList: [],
        PdmConfigKeyListLoading: false,
        PdmConfigKeyEntity: null,
        PdmConfigKeyShowDlg: false,
        AddPdmConfigKeyShowDlg: false,
    },
    mutations: {
        setPdmConfigKeyList(state, dataList) {
            state.PdmConfigKeyList = [...dataList]
        },
        setPdmConfigKeyListLoading(state, visible) {
            state.PdmConfigKeyListLoading = visible
        },
        setPdmConfigKeyShowDlg(state, visible) {
            state.PdmConfigKeyShowDlg = visible
        },
        setAddPdmConfigKeyShowDlg(state, visible) {
            state.AddPdmConfigKeyShowDlg = visible
        },
        setPdmConfigKeyEntity(state, entity) {
            state.PdmConfigKeyEntity = entity
        },
    },
    actions: {
        //创建对象
        actCreatePdmConfigKey({ commit }, parm) {
            return new Promise((resolve, reject) => {
                CreatePDM_CONFIG_KEYEntity(parm).then(res => {
                    if (res.Code == 0) {
                        commit('setPdmConfigKeyEntity', res.Data)
                        commit('setPdmConfigKeyShowDlg', true)
                         //msg.success(res.Message)
                        resolve(res)
                    } else {
                        dlg.alert(res.Message)
                        reject(res)
                    }
                })
            }).catch(err => {
                console.log(err)
            })
        },
        //加载对象
        actGetPdmConfigKeyEntity({ commit }, parm) {
            return new Promise((resolve) => {
                commit('setPdmConfigKeyListLoading', true)
                GetPDM_CONFIG_KEYEntity(parm).then(res => {
                    if (res.Code == 0) {
                        commit('setPdmConfigKeyList', res.Data)
                        //msg.success(res.Message)
                        resolve(res)
                    } else {
                        dlg.alert(res.Message)
                        //msg.error(res.Message)
                    }
                }).finally(() => {
                    commit('setPdmConfigKeyListLoading', false)
                })
            }).catch(err => {
                console.log(err)
            })
        },
        //加载列表
        actGetPdmConfigKeyList({ commit }, parm) {
            return new Promise((resolve) => {
                commit('setPdmConfigKeyListLoading', true)
                GetPDM_CONFIG_KEYList(parm).then(res => {
                    if (res.Code == 0) {
                        commit('setPdmConfigKeyList', res.Data)
                        //msg.success(res.Message)
                        resolve(res)
                    } else {
                        dlg.alert(res.Message)
                        //msg.error(res.Message)
                    }
                }).finally(() => {
                    commit('setPdmConfigKeyListLoading', false)
                })
            }).catch(err => {
                console.log(err)
            })
        },
        //分页加载列表
        actGetPdmConfigKeyListByPage({ commit }, parm) {
            return new Promise((resolve) => {
                commit('setPdmConfigKeyListLoading', true)
                GetPDM_CONFIG_KEYListByPage(parm).then(res => {
                    if (res.Code == 0) {
                        commit('setPdmConfigKeyList', res.Data)
                        //msg.success(res.Message)
                        resolve(res)
                    } else {
                        dlg.alert(res.Message)
                       // msg.error(res.Message)
                    }
                }).finally(() => {
                    commit('setPdmConfigKeyListLoading', false)
                })
            }).catch(err => {
                console.log(err)
            })
        },
        //保存信息
        actUpdatePdmConfigKey({ commit }, parm) {
            return new Promise((resolve) => {
                UpdatePDM_CONFIG_KEYEntity(parm).then(res => {
                    if (res.Code == 0) {
                        commit('setPdmConfigKeyShowDlg', false)
                        msg.success(res.Message)
                        resolve(res)
                    } else {
                        dlg.alert(res.Message)
                        resolve(res)
                    }
                })
            }).catch(err => {
                console.log(err)
            })
        },
        //编辑PDM_CONFIG_KEY
        actEditPdmConfigKeyData({ commit }, entity) {
            return new Promise((resolve) => {
                let parm = {                    
                    PdmConfigKeyID : entity.PdmConfigKeyID
                }
                GetPDM_CONFIG_KEYEntity(parm).then(res => {
                    if (res.Code == 0) {
                        // var info = {}
                        // Object.assign(info,state.getTableNameL3(TableName.Name)%>Entity)
                        // Object.assign(info,res.Data)
                        // commit('getTableNameL3(TableName.Name)%>Entity', info)
                        commit('setPdmConfigKeyEntity', res.Data)
                        commit('setPdmConfigKeyShowDlg', true)
                        msg.success(res.Message)
                        resolve(res)
                    } else {
                        dlg.alert(res.Message)
                        resolve(res)
                    }
                })
            }).catch(err => {
                console.log(err)
            })
        },
        //编辑PDM_CONFIG_KEY ,传对象过来
        actEditPdmConfigKey({ commit }, entity) {
            return new Promise(() => {
                commit('setPdmConfigKeyEntity', entity)
                commit('setPdmConfigKeyShowDlg', true)
            }).catch(err => {
                console.log(err)
            })
        },
        //删除PDM_CONFIG_KEY
        actDeletePdmConfigKey({ commit }, e) {
            return new Promise((resolve) => {
                dlg.confirm("是否确定要删除当前？").onOk(() => {
                    DeletePDM_CONFIG_KEYEntity(e).then(res => {
                        if (res.Code == 0) {
                            commit('setPdmConfigKeyShowDlg', false)
                           
                            msg.success("删除成功。")
                            resolve(res)
                        } else {
                            dlg.alert("删除失败，原因:" + res.Message)
                            //msg.success("删除失败，原因:" + res.Message)
                            resolve(res)
                        }
                    })
                })
            }).catch(err => {
                console.log(err)
            })
        }
    }
}


